import { Col } from "react-bootstrap";

// vizlink.css sets .card { min-height: 450px } — reset for cards nested inside VzPageContainer
export const SCR_V2_NESTED_CARD_STYLE = { minHeight: "auto" };

export const renderScrV2SummaryColumn = (name, value, colProps = {}) => {
  const { lg = 3, md = 6, sm = 12, className = "mb-1 mb-md-0" } = colProps;
  return (
    <Col lg={lg} md={md} sm={sm} className={className}>
      <label
        className="d-block mb-0 text-muted text-uppercase"
        style={{ fontSize: "0.78rem", lineHeight: 1.25, letterSpacing: "0.02em" }}
      >
        {name}
      </label>
      <div className="font-weight-bold text-break" style={{ fontSize: "0.92rem", lineHeight: 1.35 }}>
        {value ?? "-"}
      </div>
    </Col>
  );
};

export const ScrV2SummaryKpi = ({ icon, iconBg, title, amount, detail, footer, colClassName = "" }) => (
  <Col lg={4} md={4} sm={12} className={`mb-2 mb-lg-0 d-flex scr-summary-kpi-col ${colClassName}`.trim()}>
    <div className="card border mb-0 w-100 scr-summary-kpi-card" style={SCR_V2_NESTED_CARD_STYLE}>
      <div
        className="card-body px-2 position-relative scr-summary-kpi-body"
        style={{ paddingTop: "0.95rem", paddingBottom: "1rem" }}
      >
        {detail ? (
          <div
            className="text-muted text-right position-absolute scr-summary-kpi-detail"
            style={{
              top: "0.85rem",
              right: "0.65rem",
              fontSize: "0.82rem",
              lineHeight: 1.2,
              maxWidth: "58%",
            }}
          >
            {detail}
          </div>
        ) : null}
        <div className="d-flex align-items-center">
          <span
            className={`d-inline-flex align-items-center justify-content-center rounded ${iconBg} text-white mr-2 flex-shrink-0`}
            style={{ width: 38, height: 38, fontSize: "0.9rem" }}
          >
            <i className={`fas ${icon}`} />
          </span>
          <div className="flex-grow-1 min-w-0 pr-3">
            <div className="text-muted mb-0" style={{ fontSize: "0.92rem", lineHeight: 1.3 }}>
              {title}
            </div>
            <div
              className="font-weight-bold text-dark text-break"
              style={{ fontSize: "1.28rem", lineHeight: 1.25 }}
            >
              {amount}
            </div>
          </div>
        </div>
        {footer}
      </div>
    </div>
  </Col>
);

export const getScrV2CollectionEfficiencyVariant = (rate) => {
  if (rate >= 80) {
    return "success";
  }
  if (rate >= 50) {
    return "warning";
  }
  return "danger";
};

export const getScrV2CollectionEfficiencyColor = (rate) => {
  if (rate >= 80) {
    return "#20c997";
  }
  if (rate >= 50) {
    return "#ffc107";
  }
  return "#dc3545";
};
